var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBabymamLogoDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 46,
    viewBox: "0 0 160 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4728_20323)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 15.3905V44.3567C2.86736 44.7078 5.6762 44.9419 8.54356 45.0004C24.4603 45.0004 30.6632 37.8613 30.6632 29.8444C30.7217 19.3697 18.8427 13.8691 0 15.3905Z",
    fill: "url(#paint0_linear_4728_20323)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M23.0207 18.4123C23.9415 16.6608 24.4028 14.7373 24.5189 12.8138C24.4603 6.70093 17.6138 -1.17528 0 0.176603V15.3905C9.78252 14.6006 17.6881 15.7034 23.0207 18.4123Z",
    fill: "url(#paint1_linear_4728_20323)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.8501 31.4996H49.1501C52.4501 31.4996 55.0001 29.3996 55.0001 26.3246C55.0001 23.1746 52.5251 22.2746 52.2751 22.2246C52.5251 22.1496 54.1001 21.1246 54.1001 18.9996C54.1001 15.3246 51.3751 13.9996 48.5251 13.9996H42.8501V31.4996ZM49.0501 28.6496H45.8501V23.9996H49.0501C50.7001 23.9996 51.9501 24.6746 51.9501 26.3246C51.9501 27.9746 50.7001 28.6496 49.0501 28.6496ZM45.8501 21.1496V16.8496H48.4251C49.9001 16.8496 51.0501 17.4746 51.0501 18.9996C51.0501 20.5246 50.1001 21.1496 48.4251 21.1496H45.8501Z",
    fill: "#6B1D66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8962 29.2996C60.9712 29.2996 59.7462 29.0246 59.7462 27.7746C59.7462 26.4996 61.0212 26.0996 61.9462 26.0996C63.5712 26.0996 64.6462 26.6996 64.6462 26.6996V27.9246C64.6462 27.9246 63.6962 29.2996 61.8962 29.2996ZM62.2462 19.3496C59.7712 19.3496 57.5712 20.4246 57.5712 20.4246L58.5462 22.8996C58.5462 22.8996 60.3712 22.0246 62.0962 22.0246C63.1462 22.0246 64.6462 22.5246 64.6462 24.0746V24.7496C64.6462 24.7496 63.5212 23.8996 61.3462 23.8996C58.7712 23.8996 56.6962 25.5496 56.6962 27.8246C56.6962 30.3496 58.7462 31.7996 60.9712 31.7996C63.6462 31.7996 64.8712 29.9996 64.8712 29.9996V31.4996H67.6462V23.7746C67.6462 21.0746 65.6462 19.3496 62.2462 19.3496Z",
    fill: "#6B1D66"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9995 31.4996H73.7745V29.9496C73.7745 29.9496 74.7995 31.7996 77.3495 31.7996C80.4245 31.7996 83.1245 29.2246 83.1245 25.5746C83.1245 21.9246 80.4245 19.3496 77.3495 19.3496C75.0995 19.3496 73.9995 20.8996 73.9995 20.8996V12.5996H70.9995V31.4996ZM73.9995 23.7996C73.9995 23.7996 74.8495 22.1496 76.8245 22.1496C78.8495 22.1496 80.0745 23.6246 80.0745 25.5746C80.0745 27.5246 78.8495 28.9996 76.8245 28.9996C74.8495 28.9996 73.9995 27.3496 73.9995 27.3496V23.7996Z",
    fill: "#6B1D66"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3224 36.2996C84.3224 36.2996 85.6974 37.5496 87.4974 37.5496C89.2474 37.5496 90.9224 36.7496 91.9474 34.1496L97.6974 19.6496H94.4724L91.3474 28.3246L87.3474 19.6496H84.0224L89.7974 31.7746L89.3224 32.9996C88.7474 34.4496 88.3224 34.7496 87.2974 34.7496C86.5224 34.7496 85.7224 33.9746 85.7224 33.9746L84.3224 36.2996Z",
    fill: "#6B1D66"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M106.937 13.9996V31.4996H109.937V19.7496L115.412 28.0746L120.887 19.7496V31.4996H123.887V13.9996H121.112L115.412 22.7996L109.712 13.9996H106.937Z",
    fill: "#6B1D66"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M131.891 29.2996C130.966 29.2996 129.741 29.0246 129.741 27.7746C129.741 26.4996 131.016 26.0996 131.941 26.0996C133.566 26.0996 134.641 26.6996 134.641 26.6996V27.9246C134.641 27.9246 133.691 29.2996 131.891 29.2996ZM132.241 19.3496C129.766 19.3496 127.566 20.4246 127.566 20.4246L128.541 22.8996C128.541 22.8996 130.366 22.0246 132.091 22.0246C133.141 22.0246 134.641 22.5246 134.641 24.0746V24.7496C134.641 24.7496 133.516 23.8996 131.341 23.8996C128.766 23.8996 126.691 25.5496 126.691 27.8246C126.691 30.3496 128.741 31.7996 130.966 31.7996C133.641 31.7996 134.866 29.9996 134.866 29.9996V31.4996H137.641V23.7746C137.641 21.0746 135.641 19.3496 132.241 19.3496Z",
    fill: "#6B1D66"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M154.395 19.3496C151.62 19.3496 150.62 21.4246 150.62 21.4246C150.62 21.4246 149.795 19.3496 146.945 19.3496C144.52 19.3496 143.445 21.3746 143.445 21.3746V19.6496H140.645V31.4996H143.645V23.6746C143.645 23.6746 144.395 22.1496 145.97 22.1496C147.47 22.1496 148.095 23.0246 148.095 24.6496V31.4996H151.095V23.6746C151.095 23.6746 151.845 22.1496 153.42 22.1496C154.92 22.1496 155.545 23.0246 155.545 24.6496V31.4996H158.545V23.8746C158.545 21.0246 156.795 19.3496 154.395 19.3496Z",
    fill: "#6B1D66"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4728_20323",
    x1: 0,
    y1: 30.0854,
    x2: 30.7159,
    y2: 30.0854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A58398",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A58398"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4728_20323",
    x1: 0,
    y1: 9.2403,
    x2: 24.4779,
    y2: 9.2403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A58398",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A58398"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4728_20323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.7217,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBabymamLogoDesktop);
export default __webpack_public_path__ + "static/media/babymam-logo-desktop.f44b9ddeda72e668edcccf63403ada4c.svg";
export { ForwardRef as ReactComponent };